export enum RequestAttributeEnum {
	directive = 1,
	exchange = 2
}